export default __webpack_public_path__ + "static/media/wanda.c9786a30.JPG";